import validate from 'validate.js';
import { get } from 'lodash';

export const validateInquiryForm = (values, props) => {
  const {
    tags,
    number_of_guests,
    alcohol_consumed,
    message
  } = values;

  return {
    tags: validate.single(get(tags, 'activity', null), {
      presence: {
        allowEmpty: false,
        message: props.intl.formatMessage({ id: 'inquiry_booking.validate_inquiry_form.enter_activity', defaultMessage: 'Please select an activity.' })
      }
    }),
    number_of_guests: validate.single(number_of_guests, {
      presence: {
        allowEmpty: false,
        message: props.intl.formatMessage({ id: 'inquiry_booking.validate_inquiry_form.enter_attendees', defaultMessage: 'Please enter the number of attendees.' })
      }
    }),
    alcohol_consumed: validate.single(alcohol_consumed, {
      presence: {
        allowEmpty: false,
        message: props.intl.formatMessage({ id: 'inquiry_booking.validate_inquiry_form.alcohol_option', defaultMessage: 'Please select an option.' })
      }
    }),
    message: validate.single(message, {
      presence: {
        allowEmpty: false,
        message: props.intl.formatMessage({ id: 'inquiry_booking.validate_inquiry_form.enter_message', defaultMessage: 'Please enter a message.' })
      },
      length: {
        minimum: 1,
        tooShort: props.intl.formatMessage({ id: 'inquiry_booking.validate_inquiry_form.min_characters', defaultMessage: 'Minimum is {count} characters.' }, { count: props.intl.formatNumber(6) }),
        maximum: 10000,
        tooLong: props.intl.formatMessage({ id: 'inquiry_booking.validate_inquiry_form.max_characters', defaultMessage: 'Maximum is {count} characters.' }, { count: props.intl.formatNumber(10000) })
      }
    })
  };
};
